import React from "react";
import AppModal from "../common/AppModal";
import AdjustStockForm from "../../forms/AdjustStockForm";
import { StockLevelResponseDto } from "../../shared/dtos/stockLevel/StockLevelResponseDto";

interface AdjustStockModalProps {
  open: boolean;
  onClose: () => void;
  stockLevel: StockLevelResponseDto;
  loading: boolean;
  error: string | null;
}

const AdjustStockModal: React.FC<AdjustStockModalProps> = ({
  open,
  onClose,
  stockLevel,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Adjust Inventory Stock"
    width="sm"
    loading={loading}
  >
    <AdjustStockForm stockLevel={stockLevel} loading={loading} error={error} />
  </AppModal>
);

export default AdjustStockModal;
